<template>
    <div class="login">
        <LoginSSO type="login-page"/>
    </div>
</template>

<script>
    import LoginSSO from 'components/user/LoginSSO'

    export default {
        components: {
            LoginSSO
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('setPreviousPathBeforeLogin', from.fullPath)
            })
        }
    }
</script>

<style lang="scss" scoped>
    .login {
        padding: 100px 0 !important;
    }
</style>
